import React, { useEffect, useState } from "react";

import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import Icon from "@mui/material/Icon";
import MDTypography from "components/MDTypography";

import DateTimePicker from "react-datetime-picker";
import Pagination from "@mui/material/Pagination";
import Swal from "sweetalert2";

import Loader from "Loader";
import CreateSessionReq2 from "../../Classes/Models/Requests/Administration/CreateSessionReq";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "App";
import SessionsApi from "Classes/API/Administration/SessionsApi";
import SearchStringOrIntReq2 from "Classes/Models/Requests/SearchStringOrIntReq";
import DataTable from "examples/Tables/DataTable";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";

const SessionsTable = ({ setCreatedNewSession, CreatedNewSession }) => {
  let navigate = useNavigate();
  const { translations } = useContext(LanguageContext);

  const TableColumns = [
    {
      Header: translations.FacilityPagesCreatenewFacilityTypename,
      accessor: "Name",
      align: "left",
    },

    {
      Header: translations.FacilityPagesCreatenewFacilityTypedescription,
      accessor: "Description",
      width: "30%",
      align: "left",
    },
    {
      Header: translations.FacilityPagesCreatenewFacilityTypecategory,
      accessor: "Category",
      align: "left",
    },

    { Header: translations.sessionPgSessionsSecretName, accessor: "SecretName", align: "center" },
    {
      Header: translations.sessionPgSessionsEgyptianPrice,
      accessor: "EgyptianPrice",
      align: "center",
    },
    { Header: translations.sessionPgSessionsArabPrice, accessor: "ArabPrice", align: "left" },
    { Header: translations.sessionPgSessionsOtherPrice, accessor: "OtherPrice", align: "left" },
    // {
    //   Header: translations.sessionPgSessionsIsHalfDuration,
    //   accessor: "IsHalfDuration",
    //   align: "left",
    // },
    // {
    //   Header: translations.sessionPgSessionsIsAssessmentSession,
    //   accessor: "IsAssessmentSession",
    //   align: "left",
    // },
    // {
    //   Header: translations.FacilityPagesCreatenewFacilityTypeImage,
    //   accessor: "Image",
    //   align: "left",
    // },

    { Header: translations.PatientStaytableDetails, accessor: "Edit", align: "center" },
    {
      Header: translations.FacilityPagesCreatenewFacilityTypedelete,
      accessor: "Delete",
      align: "center",
    },
  ];

  const [TableDataRows, setTableDataRows] = useState([]);
  const [ResponseData, setResponseData] = useState({});
  const [PaginationPages, setPaginationPages] = useState(0);
  const [Page, setPage] = useState(1);

  const [IsLoaded, setIsLoaded] = useState(false);

  const [NameSearch, setNameSearch] = useState("");
  const [DescriptionSearch, setDescriptionSearch] = useState("");
  const [CategorySearch, setCategorySearch] = useState("");
  const [SecretNameSearch, setSecretNameSearch] = useState("");
  const [EgyptianPriceSearch, setEgyptianPriceSearch] = useState("");
  const [ArabPriceSearch, setArabPriceSearch] = useState("");
  const [OtherPriceSearch, setOtherPriceSearch] = useState("");
  const [IsHalfDurationSearch, setIsHalfDurationSearch] = useState();
  const [IsAssessmentSessionSearch, setIsAssessmentSessionSearch] = useState();

  const DeleteSession = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.value) {
        let SearchStringOrIntReq = new SearchStringOrIntReq2();

        SearchStringOrIntReq.SearchInt = id;
        var res = await SessionsApi.DeleteSession(SearchStringOrIntReq);

        if (res.status == "Success") {
          setIsLoaded(false);
          Swal.fire("Deleted!", "Your file has been deleted.", "success");
          GetSessions();
        } else {
          Swal.fire("Error!", "Something went wrong.", "error");
        }
      }
    });
  };

  const GetOptions = (session) => {
    navigate("/Sessions/Details", {
      state: {
        SearchSession: session,
      },
    });
  };

  const MakeTableRow = (session, index) => {
    return {
      Name: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.name}
        </MDTypography>
      ),

      Description: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.description}
        </MDTypography>
      ),
      Category: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.category}
        </MDTypography>
      ),
      SecretName: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.secretName}
        </MDTypography>
      ),

      EgyptianPrice: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.egyptianPrice}
        </MDTypography>
      ),

      ArabPrice: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.arabPrice}
        </MDTypography>
      ),

      OtherPrice: (
        <MDTypography component="p" variant="button" color="text" fontWeight="medium">
          {session.otherPrice}
        </MDTypography>
      ),

      // IsHalfDuration: (
      //   <input
      //     id={"S.IsHalfDuration" + session.id}
      //     type="checkbox"
      //     disabled="true"
      //     defaultChecked={session.isHalfDuration}
      //   />
      // ),

      // IsAssessmentSession: (
      //   <input
      //     id={"S.IsAssessmentSession" + session.id}
      //     type="checkbox"
      //     disabled
      //     defaultChecked={session.isAssessmentSession}
      //   />
      // ),

      Image: session.image && (
        <img
          style={{ width: "auto", height: "4em" }}
          id={"image" + session.id}
          src={"data:image/png;base64," + session.image}
        ></img>
      ),
      Edit: (
        <MDTypography
          onClick={() => {
            GetOptions(session);
          }}
          component="a"
          variant="button"
          color="text"
          fontWeight="medium"
        >
          <Icon>more_vert</Icon>
        </MDTypography>
      ),
      Delete: (
        <MDButton onClick={() => DeleteSession(session.id)} variant="gradient" color="dark">
          <Icon sx={{ fontWeight: "bold" }}>delete</Icon>
        </MDButton>
      ),
    };
  };

  let _createSessionReq = new CreateSessionReq2();

  const GetTableData = async () => {
    _createSessionReq.pagingParams.pageNumber = Page;
    _createSessionReq.pagingParams.pageSize = 5;
    _createSessionReq.Name = NameSearch;
    _createSessionReq.Description = DescriptionSearch;
    _createSessionReq.Category = CategorySearch;
    _createSessionReq.SecretName = SecretNameSearch;
    _createSessionReq.EgyptianPrice = EgyptianPriceSearch;
    _createSessionReq.ArabPrice = ArabPriceSearch;
    _createSessionReq.OtherPrice = OtherPriceSearch;
    _createSessionReq.IsHalfDuration = IsHalfDurationSearch;
    _createSessionReq.IsAssessmentSession = IsAssessmentSessionSearch;
    _createSessionReq.Id = "";
    _createSessionReq.Image = undefined;

    console.log(_createSessionReq);

    var res = await SessionsApi.SearchSessions(_createSessionReq);

    if (res.status == "Success") {
      let tempResponseData = [...res.data.list];
      setPaginationPages(res.data.totalPages);

      // var resList = res.data.list;

      setResponseData(tempResponseData);
      // setTableDataRows(rows);
      setIsLoaded(true);
    }
  };

  useEffect(async () => {
    console.log(Page);

    GetTableData();
  }, [Page]);

  const RefreshTable = (resList) => {
    var rows = [];
    resList.forEach((session, index) => {
      rows.push(MakeTableRow(session, index));
    });
    setTableDataRows(rows);
  };

  useEffect(async () => {
    //Get data

    if (!IsLoaded || CreatedNewSession) {
      setCreatedNewSession(false);
      await GetTableData();
    }
  }, [IsLoaded, CreatedNewSession]);

  useEffect(() => {
    //Get data

    if (ResponseData.length > 0) {
      RefreshTable(ResponseData);
    }
  }, [ResponseData]);

  const onSearch = async () => {
    setIsLoaded(false);
    let CreateSessionReq = new CreateSessionReq2();

    CreateSessionReq.Name = NameSearch;
    CreateSessionReq.Description = DescriptionSearch;
    CreateSessionReq.Category = CategorySearch;
    CreateSessionReq.SecretName = SecretNameSearch;
    CreateSessionReq.EgyptianPrice = EgyptianPriceSearch;
    CreateSessionReq.ArabPrice = ArabPriceSearch;
    CreateSessionReq.OtherPrice = OtherPriceSearch;
    CreateSessionReq.IsHalfDuration = IsHalfDurationSearch;
    CreateSessionReq.IsAssessmentSession = IsAssessmentSessionSearch;
    CreateSessionReq.Id = "";

    var res = await SessionsApi.SearchSessions(CreateSessionReq);

    if (res.status == "Success") {
      let tempResponseData = [...res.data.list];
      setPaginationPages(res.data.totalPages);

      // var resList = res.data.list;

      setResponseData(tempResponseData);
      // setTableDataRows(rows);
      setIsLoaded(true);
    } else {
      Swal.fire({
        title: "Error",
        text: res.message,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <>
      <Card mb={3} className="mt-4 p-3" sx={{ marginBottom: "2em" }}>
        <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
          <MDTypography variant="h6" fontWeight="medium">
            {translations.sessionPgSessionsSearch}
          </MDTypography>
        </MDBox>
        <div className={translations.setlang === "ar" ? "rtl-label" : ""}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-4 mt-3">
                <MDInput
                  className="full-width"
                  onChange={(e) => setNameSearch(e.target.value)}
                  label={translations.FacilityPagesCreatenewFacilityTypename}
                  fullWidth
                ></MDInput>
              </div>
              <div className="col-md-4 mt-3">
                <MDInput
                  className="full-width"
                  onChange={(e) => setDescriptionSearch(e.target.value)}
                  label={translations.FacilityPagesCreatenewFacilityTypedescription}
                  fullWidth
                ></MDInput>
              </div>
              <div className="col-md-4 mt-3">
                <MDInput
                  className="full-width"
                  onChange={(e) => setCategorySearch(e.target.value)}
                  label={translations.FacilityPagesCreatenewFacilityTypecategory}
                  fullWidth
                ></MDInput>
              </div>
              <div className="col-md-4 mt-3">
                <MDInput
                  className="full-width"
                  type={"text"}
                  onChange={(e) => setSecretNameSearch(e.target.value)}
                  label={translations.sessionPgSessionsSecretName}
                  fullWidth
                ></MDInput>
              </div>
              <div className="col-md-4 mt-3">
                <MDInput
                  className="full-width"
                  type={"number"}
                  onChange={(e) => setEgyptianPriceSearch(e.target.value)}
                  label={translations.sessionPgSessionsEgyptianPrice}
                  fullWidth
                ></MDInput>
              </div>
              <div className="col-md-4 mt-3">
                <MDInput
                  className="full-width"
                  type={"number"}
                  onChange={(e) => setArabPriceSearch(e.target.value)}
                  label={translations.sessionPgSessionsArabPrice}
                  fullWidth
                ></MDInput>
              </div>
              <div className="col-md-4 mt-3">
                <MDInput
                  className="full-width"
                  type={"number"}
                  onChange={(e) => setOtherPriceSearch(e.target.value)}
                  label={translations.sessionPgSessionsOtherPrice}
                  fullWidth
                ></MDInput>
              </div>
              {/* <div className="col-md-4 mt-3">
                <label>
                  <input
                    type="checkbox"
                    className="mr-2"
                    defaultChecked={IsHalfDurationSearch}
                    onChange={() => setIsHalfDurationSearch(!IsHalfDurationSearch)}
                  />
                  {translations.sessionPgSessionsIsHalfDuration}
                </label>
              </div>
              <div className="col-md-4 mt-3">
                <label>
                  <input
                    type="checkbox"
                    className="mr-2"
                    defaultChecked={IsAssessmentSessionSearch}
                    onChange={() => setIsAssessmentSessionSearch(!IsAssessmentSessionSearch)}
                  />
                  {translations.sessionPgSessionsIsAssessmentSession}
                </label>
              </div> */}
            </div>
            <div className="col-md-12 text-right">
              <MDButton
                type="button"
                className="btn btn-primary mt-2 float-right"
                sx={{ backgroundColor: "#3560AD", "&:hover": { backgroundColor: "#4682B4" } }}
                color="text"
                onClick={onSearch}
              >
                {translations.sessionPgSessionsSearch}
              </MDButton>
            </div>
          </div>
        </div>
      </Card>
      {!IsLoaded ? (
        <Loader />
      ) : (
        <Card>
          <MDBox
            mx={2}
            mt={-3}
            py={3}
            px={2}
            sx={{ backgroundColor: "#3560AD" }}
            bgColor="info"
            borderRadius="lg"
            coloredShadow="info"
          >
            <MDTypography variant="h6" color="white" textAlign="center">
              {translations.sessionPgSessionsSessionTypesTable}
            </MDTypography>
          </MDBox>
          <MDBox pt={3}>
            <DataTable
              table={{ columns: TableColumns, rows: TableDataRows }}
              isSorted={false}
              entriesPerPage={false}
              showTotalEntries={false}
              noEndBorder
            />
          </MDBox>
          <div className="text-right mx-3 my-4">
            <Pagination
              count={PaginationPages}
              color="primary"
              onChange={(e, num) => setPage(num)}
              className="float-right"
            />
          </div>
        </Card>
      )}
    </>
  );
};

export default SessionsTable;
